/* ES PERF (extreme)
 * Drawer cart init extracted from theme.liquid so we can defer the heavy vendor scripts.
 * Shopify serves this .js.liquid file as a .js asset.
 */
(function () {
  function initOnce() {
    if (window.__esAjaxCartInited) return true;
    if (!window.jQuery || !window.ajaxCart || !window.Handlebars) return false;

    window.__esAjaxCartInited = true;

    var ajaxCartConfig = {
      cartContainer: '.enj-minicart-ajax',
      addToCartSelector: '.enj-add-to-cart-btn',
      cartCountSelector: '.enj-cartcount',
      cartCostSelector: '.enj-cartcost',
      moneyFormat: null,
      // ES: Strings for consistent empty cart state (used by ajax-cart.js & quickview.js)
      emptyText: "Du hast noch keine Artikel im Warenkorb.",
      shopNowText: "Weiter einkaufen",
      shopNowUrl: null
    };

    try {
      window.ajaxCartConfig = ajaxCartConfig;
    } catch (e) {}

    window.jQuery(function ($) {
      try {
        ajaxCart.init(ajaxCartConfig);
      } catch (e) {}
    });

    window.jQuery('body').on('ajaxCart.afterCartLoad', function (evt, cart) {
      // Hook point: run custom JS after cart HTML is injected.
    });

    return true;
  }

  function boot() {
    if (initOnce()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (initOnce() || tries > 20) {
        clearInterval(timer);
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();